/*
==========================================================
Ankur Inactive Tab - BeadsnFashion
==========================================================
Changes the browser tab title when the user switches tabs.
Restores the original title when they return.
==========================================================
*/

document.addEventListener("DOMContentLoaded", function () {

    const originalTitle = document.title;

    const messages = [
    "❤️ BeadsnFashion",
    "💎 Gemstones Beads",
    "🍀 Charms",
    "📿 Necklace",
    "🧿 Evil Eye Pendants",
    "🧵 Thread, Wire & Stringing Materials",
    "✂️ DIY Jewellery Making Kits",
    "💎 Free Offers on Beads & Findings",
    "🚚 Fast Shipping",
    "✈️ International Shipping",
    "🛍️ Your cart is waiting!",
    "🎁 Thousands of Jewellery Components"
    
    ];

    let interval = null;
    let index = 0;

    document.addEventListener("visibilitychange", function () {

        if (document.hidden) {

            if (interval) return;

            interval = setInterval(function () {
                document.title = messages[index];
                index = (index + 1) % messages.length;
            }, 500);

        } else {

            clearInterval(interval);
            interval = null;
            index = 0;
            document.title = originalTitle;

        }

    });

});